// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../../../common/GlobalContext";
import Color from "color";

type $Props = {
  hideMortgageCalc: boolean,
  backgroundImage: string,
  classes: Object,
};

const MortgageCalculator = ({ classes }) => (
  <div className={classes.circleContainer}>
    <a
      className={classes.circle}
      href="/mortgage-calculator"
      title="Mortgage calculator"
    >
      <span>
        Mortgage
        <br />
        <strong>calculator</strong>
      </span>
    </a>
  </div>
);

const renderMortgageCalculator = (
  hideMortgageCalc: boolean,
  classes: Object
) => {
  if (!hideMortgageCalc) {
    return <MortgageCalculator classes={classes} />;
  } else return;
};

const TransparentCircles = ({
  hideMortgageCalc,
  backgroundImage,
  classes,
}: $Props) => {
  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20,0.5), rgba(20, 20, 20, 0.5)), url(${backgroundImage}) center/cover`,
      }}
    >
      <div className={classes.circleContainer}>
        <a className={classes.circle} href="/sell" title="Free market analysis">
          <span>
            Free Market
            <br />
            <strong>analysis</strong>
          </span>
        </a>
      </div>
      <div className={classes.circleContainer}>
        <a
          className={classes.circle}
          href="/tips/buying"
          title="Tips for home buying"
        >
          <span>
            Tips for
            <br />
            <strong>home buying</strong>
          </span>
        </a>
      </div>
      <div className={classes.circleContainer}>
        <a
          className={classes.circle}
          href="/tips/selling"
          title="Tips for home selling"
        >
          <span>
            Tips for
            <br />
            <strong>home selling</strong>
          </span>
        </a>
      </div>
      {renderMortgageCalculator(hideMortgageCalc, classes)}
    </div>
  );
};

const styles = (theme) => {
  const primaryBg = Color(theme.colors.primary["500"])
    .rgb()
    .fade(0.5)
    .string();
  return {
    root: {
      display: "flex",
      position: "relative",
      flexFlow: "row wrap",
      justifyContent: "center",
      alignItems: "center",
      padding: "46px 40px 23px",
      textAlign: "center",
    },
    circleContainer: {
      flex: "0 1 auto",
      padding: "0 14px",
      margin: "0 32px 24px",
    },
    circle: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "190px",
      width: "190px",
      backgroundColor: primaryBg,
      borderRadius: "50%",
      border: "5px solid rgba(255,255,255,.5)",
      fontSize: "1.5rem",
      textTransform: "uppercase",
      color: theme.colors.white,
      transition: "all 250ms ease",
      "& strong": {
        fontWeight: "bold",
      },
      "&:hover, &:focus": {
        textDecoration: "none",
        backgroundColor: theme.colors.secondary["500"],
        color: theme.colors.white,
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(TransparentCircles));
